import { useEffect, useRef } from "react";
import { useReducedMotion } from "motion/react";
import { useLocation } from "react-router-dom";
import Home from "../views/home";
import MobileServices from "./mobile-services";
import MobileWhyUs from "./mobile-why-us";
import MobileContact from "./mobile-contact";
import { scrollToSection } from "@/lib/scroll-to-section";

const pathToSection: Record<string, string> = {
  "/": "home",
  "/services": "services",
  "/why-us": "why-us",
  "/contact": "contact",
};

export default function MobilePage() {
  const location = useLocation();

  const reduceMotion = useReducedMotion();
  const isFirstRoute = useRef(true);

  useEffect(() => {
    const sectionId = pathToSection[location.pathname] ?? "home";
    const animate = !isFirstRoute.current && !reduceMotion;
    isFirstRoute.current = false;
    const frame = window.requestAnimationFrame(() =>
      scrollToSection(sectionId, { animate })
    );

    return () => window.cancelAnimationFrame(frame);
  }, [location.pathname, reduceMotion]);

  return (
    <main className="relative z-10 w-full">
      <section
        id="home"
        data-mobile-section="home"
        className="mx-auto flex h-[calc(100svh+4rem)] min-h-[740px] w-full scroll-mt-18 overflow-hidden px-4"
      >
        <Home />
      </section>
      <MobileServices />
      <MobileWhyUs />
      <MobileContact />
    </main>
  );
}
